import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { IProductV1 } from "src/domain/entities"
import { productDeleteService } from "src/domain/services/product/productDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	product: IProductV1
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const ProductDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	product,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleProductDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await productDeleteService({ id: product.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [product, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Product: ${product.name}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleProductDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
